"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("./Button"));

var _deprecatedPropType = _interopRequireDefault(require("../../utils/deprecated-prop-type"));

var _excluded = ["children", "className", "disabled", "ghost", "primary", "secondary", "selected", "tertiary", "working", "destructive", "variant"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*
    Button Wrapper is used to map the old props to the new props
*/
var getVariant = function getVariant(_ref) {
  var secondary = _ref.secondary,
      tertiary = _ref.tertiary;

  if (secondary) {
    return 'secondary';
  } else if (tertiary) {
    return 'tertiary';
  } else {
    return 'primary';
  }
};

var ButtonWrapper = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ButtonWrapper, _Component);

  var _super = _createSuper(ButtonWrapper);

  function ButtonWrapper() {
    (0, _classCallCheck2.default)(this, ButtonWrapper);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ButtonWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          disabled = _this$props.disabled,
          ghost = _this$props.ghost,
          primary = _this$props.primary,
          secondary = _this$props.secondary,
          selected = _this$props.selected,
          tertiary = _this$props.tertiary,
          working = _this$props.working,
          destructive = _this$props.destructive,
          variant = _this$props.variant,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded); // subClass

      var classes = (0, _classnames.default)(className, {
        'ui-button': true,
        // [`ui-button--${subClass}`]: subClass,
        'ui-button--destructive': destructive,
        'ui-button--disabled': disabled,
        'ui-button--ghost': ghost,
        'ui-button--primary': primary,
        'ui-button--secondary': secondary,
        'ui-button--selected': selected,
        'ui-button--tertiary': tertiary,
        'ui-button--working': working
      }); // Map to new props

      return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, otherProps, {
        className: classes,
        disabled: disabled,
        destructive: destructive,
        variant: variant || getVariant({
          primary: primary,
          secondary: secondary,
          tertiary: tertiary
        }),
        ghost: ghost,
        selected: selected,
        working: working
      }), children);
    }
  }]);
  return ButtonWrapper;
}(_react.Component);

ButtonWrapper.defaultProps = {
  children: '',
  className: '',
  type: 'button'
};
ButtonWrapper.propTypes = {
  /** Button Inner Text */
  children: _propTypes.default.node.isRequired,

  /** Additional button classes */
  className: _propTypes.default.string,

  /** Deprecated: Use any system state `[destructive|success|warning]` */
  destructive: (0, _deprecatedPropType.default)(_propTypes.default.bool, 'Destructive are no longer the direction for CX'),

  /** Used in conjunction with 'aria-disabled', Use any button state [disabled|selected|working] */
  disabled: _propTypes.default.bool,

  /** State used on dark backgrounds */
  ghost: function ghost(props, propName) {
    if (props.ghost && props.primary) {
      return new Error('Invalid props combination: `' + propName + "` not allowed to be used with 'primary' at this time. Validation failed.");
    }

    if (props.ghost && typeof props.ghost !== 'boolean') {
      return new Error('Prop "ghost" should be a boolean');
    }
  },

  /** Deprecated: (Use variant) Use any one single subClass [primary|secondary|tertiary] */
  primary: (0, _deprecatedPropType.default)(_propTypes.default.bool, "Use 'variant'"),

  /** Deprecated: (Use variant) Use any one single subClass [primary|secondary|tertiary] */
  secondary: (0, _deprecatedPropType.default)(_propTypes.default.bool, "Use 'variant'"),

  /** Use any button state [disabled|selected|working] */
  selected: _propTypes.default.bool,

  /** Deprecated: (Use variant) Use any one single subClass [primary|secondary|tertiary] */
  tertiary: (0, _deprecatedPropType.default)(_propTypes.default.bool, "Use 'variant'"),

  /**  Determines the look and feel of the button */
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary']),

  /** Use any button state [disabled|selected|working] */
  working: _propTypes.default.bool
};
var _default = ButtonWrapper;
exports.default = _default;
//# sourceMappingURL=ButtonWrapper.js.map